import { useState } from "react";
import Page from "./components/Page";
import { cookieName } from "./consts/cookie";
import MainContext from "./context/MainContext";
import { Client, Model, Offer, User } from "./interfaces";
import { getCookie } from "./utils/handleCookie";

function App() {
  const [pageHeight, setPageHeight] = useState(0);

  const [tempModelList, setTempModelList] = useState<Model[] | []>([]);

  const [modelList, setModelList] = useState<Model[] | []>([]);

  const [onModelSelection, setOnModelSelection] = useState<boolean>(false);

  const [user, setUser] = useState<User | null>(null);

  const [userTreated, setUserTreated] = useState<User | null>(null);

  const [offer, setOffer] = useState<Offer | null>(null);

  const [client, setClient] = useState<Client | null>(null);

  const [model, setModel] = useState<Model | null>(null);

  const [refresh, setRefresh] = useState<boolean>(false);

  const [token, setToken] = useState<string | null>(
    getCookie(cookieName.token)
  );

  /*  const story = useStoryblok("home", { version: "draft" });

  if (!story || !story.content) {
    return <div></div>;
  } */

  return (
    <MainContext.Provider
      value={{
        pageHeight,
        setPageHeight,
        modelSelector: {
          onModelSelection,
          setOnModelSelection,
          tempModelList,
          setTempModelList,
          modelList,
          setModelList,
        },
        refresh,
        setRefresh,
        token,
        setToken,
        user,
        userTreated,
        offer,
        client,
        model,
        setUser,
        setUserTreated,
        setOffer,
        setClient,
        setModel,
      }}
    >
      {/* <StoryblokComponent blok={story.content} /> */}
      <Page />
    </MainContext.Provider>
  );
}

export default App;
